export const EVENT_NAME = {
  ATTESTATION: {
    DOWNLOAD_CLICK: 'orgaAttestationDownloadClick',
  },
  HOMEPAGE: {
    CREATE_CAMPAIGN_CLICK: 'homepageCreateCampaignClick',
    LIST_CAMPAIGNS_CLICK: 'homepageListCampaignsClick',
  },
  CAMPAIGN: {
    EXPORT_DATA_CLICK: 'campaignExportDataResultClick',
  },
  CATALOGUE: {
    SEARCH: 'catalogueSearch',
    COURSE_SELECTION_CLICK: 'catalogueCourseSelectionClick',
    CAMPAIGN_CREATION_CLICK: 'catalogueCampaignCreationClick',
  },
  COMBINED_COURSE: {
    VIEW_CAMPAIGN_CLICK: 'combinedCourseViewCampaignClick',
  },
  TUBES_SELECTION: {
    DOWNLOAD_JSON_CLICK: 'tubesSelectionDownloadJsonClick',
  },
};
